import { render, staticRenderFns } from "./v80o1020.vue?vue&type=template&id=dab17438&scoped=true"
import script from "./v80o1020.vue?vue&type=script&lang=js"
export * from "./v80o1020.vue?vue&type=script&lang=js"
import style0 from "./v80o1020.vue?vue&type=style&index=0&id=dab17438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab17438",
  null
  
)

export default component.exports